import { centsToMoney, formatLocaleDate } from '../../utils';

export const CouponTypes = {
  VIRTUAL: 1501,
  SINGLE_ORDER_DISCOUNT: 1504,
  PERIOD_DISCOUNT: 1502,
  MEMBERSHIP: 1505,
};

export const discountCouponTypes = [
  CouponTypes.SINGLE_ORDER_DISCOUNT,
  CouponTypes.PERIOD_DISCOUNT,
];

export const isDiscountCouponType = type =>
  discountCouponTypes.includes(Number(type));

export const couponFormDefaultValues = {
  type: CouponTypes.VIRTUAL,
  amount: 0,
  usage_type: 1,
  max_redeem_quantity: 1,
  discount_valid_days: 1,
  valid_from: '',
  valid_until: '',
  nominal_of_code: false,
  title_lt: '',
  title_en: '',
  title_ru: '',
  code_amount: 1,
};

export const couponDefaultValuesMapper = values => {
  if (!values) return couponFormDefaultValues;

  const mappedValues = Object.entries(values)
    .filter(([, value]) => Boolean(value))
    .reduce((acc, [key, value]) => {
      if (key === 'valid_from' || key === 'valid_until') {
        return {
          ...acc,
          [key]: value ? formatLocaleDate(value, 'yyyy-MM-dd') : undefined,
        };
      }
      if (key === 'max_redeem_quantity') {
        return {
          ...acc,
          [key]: value,
          usage_type: value > 1 ? 2 : 1,
        };
      }

      if (key === 'code') {
        return {
          ...acc,
          [key]: value,
        };
      }

      if (key === 'amount') {
        return {
          ...acc,
          [key]:
            values.type === CouponTypes.VIRTUAL && value !== undefined
              ? centsToMoney(value)
              : value,
        };
      }

      return { ...acc, [key]: value };
    }, {});

  return {
    ...mappedValues,
    nominal_of_code: Boolean(values.custom_code),
  };
};
